/* eslint-disable react-hooks/exhaustive-deps */
// react
import { useContext, useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import { Button, Col, Row } from "react-bootstrap"
import dayjs from "dayjs"

// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcInput from "@grapecity/wijmo.input"

// fortawasome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"

// other
import Decimal from "decimal.js"

// Kairos
// TODO:Modalは今後作成予定
// import { ModalOuter } from "../../../../components/Modal/ModalOuter"
import FlexGridOuter from "../../../../components/FlexGridWrapper/FlexGridOuter"
import { T区分マスタ } from "../../../../components/ComboBox/KubunComboBox"
import ComboBox from "../../../../components/ComboBox"
import { T請求内訳 } from "../../../../components/ComboBox/SeikyuUtiwakeComboBox"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../../type/wijmoComponents"
import gridPageHelper from "../../../../ts/helpers/gridPageHelper"
import CONSTANT from "../../../../constant"
import { 区分分類コード } from "../../../../constant/enum/codes"
import { メニューコード } from "../../../../constant/menuCode"
import util from "../../../../ts/util"
import {
  GridInitializedContext,
  IsRestoreSearchingContext,
  IsSearchingContext,
  SearchResultContext,
  FlexGridContext,
  seikyuGoukeiUpdateDyContext,
  seikyuSyoriStatKbnContext,
  seikyuDyContext,
} from "./InvoiceListContext"
import {
  品名Bindings,
  積卸地Bindings,
  請求Bindings,
  車輌Bindings,
} from "./InvoiceListConstant"
import InvoiceListKoteiSeikyuModal from "./InvoiceListKoteiSeikyuModal"

// TODO:ダミー
import { T請求明細入力GridItem } from "./InvoiceList"
import KubunService from "../../../../service/master/kubun/kubunService"
import NinusiSeikyuService from "../../../../service/master/ninusiseikyu/ninusiSeikyuService"
import {
  e請求支払処理状態区分,
  e請求支払区分,
  e請求支払確認区分,
} from "../../../../constant/enum/zyutuHaisya"
import _ from "lodash"
import {
  invoiceListExcelFormat,
  invoiceListPdfFormat,
} from "../../../../ts/util/exportUtil"

// 明細データの集計用
export type summaryRow = {
  請求合計ID: number
  受注配車ID: number
  荷主請求ID: number
  荷主請求内訳ID: number
  積載品ID: number
  請求運送料: number
  請求付帯料: number
  請求高速料: number
  請求合計額: number
  品数: number
}

/**
 * 請求明細入力grid部
 * @param props
 * @returns
 */
const InvoiceListGrid: React.FC<{
  searchConditionClear?: React.MouseEventHandler<HTMLElement>
  gridId: string
  区分ItemSource?: T区分マスタ[]
}> = (props) => {
  const location = useLocation()

  const 請求明細入力PathList = util.getMenuPath(
    メニューコード.請求_支払管理.請求処理
  )

  //#region [context]

  // ロード表示
  const { state: isSearching } = useContext(IsSearchingContext)
  //grid初期化フラグ
  const { state: gridInitialized, setState: setGridInitialized } = useContext(
    GridInitializedContext
  )
  // gridレストア完了フラグ
  const { state: isRestoreSearching, setState: setIsRestoreSearching } =
    useContext(IsRestoreSearchingContext)

  // 検索結果
  const searchResult = useContext(SearchResultContext)

  const { state: 請求処理状態区分コード, setState: set請求処理状態区分コード } =
    useContext(seikyuSyoriStatKbnContext)

  //#endregion

  //#region [state]
  //dataMap
  const [請求内訳DataMap, set請求内訳DataMap] =
    useState<wjcGrid.DataMap<T請求内訳>>()

  //区分系
  const [請求区分DataMap, set請求区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [課税区分DataMap, set課税区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [請求額確認区分DataMap, set請求額確認区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()

  // 請求処理状態区分
  const [請求処理状態区分ComboBox, set請求処理状態区分ComboBox] =
    useState<TWijmoComboBox<T区分マスタ["区分コード"], T区分マスタ> | null>(
      null
    )
  const [請求処理状態区分IsLoadEnded, set請求処理状態区分IsLoadEnded] =
    useState<boolean>(false)
  const [請求処理状態区分初期コード, set請求処理状態区分初期コード] = useState<
    string | null
  >(e請求支払処理状態区分.処理済)

  const [高速料項目表題, set高速料項目表題] = useState<string>("")
  const [高速料注釈, set高速料注釈] = useState<string>("")

  // 固定請求額編集モーダル
  const [isShow, setIsShow] = useState<boolean>(false)
  const [isUpdateKoteiSeikyu, setIsUpdateKoteiSeikyu] = useState<boolean>(false)
  const [請求伝票番号, set請求伝票番号] = useState<string>()
  const [is固定請求編集, setIs固定請求編集] = useState<string>("none")
  const [固定請求額差分, set固定請求額差分] = useState<number>(0)
  const [固定請求額合計, set固定請求額合計] = useState<number>(0)

  const { state: 請求合計更新日時, setState: set請求合計更新日時 } = useContext(
    seikyuGoukeiUpdateDyContext
  )
  const { state: 請求年月 } = useContext(seikyuDyContext)

  //#endregion

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<T請求明細入力GridItem>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView<T請求明細入力GridItem>(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      calculatedFields: {
        請求額合計: (item: T請求明細入力GridItem) =>
          new Decimal(item.請求高速料 ?? 0)
            .plus(item.付帯料 ?? 0)
            .plus(item.運送料 ?? 0)
            .toNumber(),
        disp品コード: (item: T請求明細入力GridItem) => {
          if (
            wjCore.isNullOrWhiteSpace(item.品コード ?? "") &&
            !wjCore.isNullOrWhiteSpace(item.品名 ?? "")
          ) {
            return "99999"
          } else {
            return item.品コード
          }
        },
      },
    })
  }

  /**
   * 合計collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createSummaryCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
    })

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダー結合
    mergeHeader(grid)

    // handler付与
    grid.formatItem.addHandler(formatItem)
    grid.beginningEdit.addHandler(beginningEdit)
    grid.cellEditEnding.addHandler(cellEditEnding)
    grid.cellEditEnded.addHandler(cellEditEnded)
    grid.refresh()
  }

  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjcGrid.FlexGrid) => {
    // header行に一行追加
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        let setHeaderText = ""
        if (積卸地Bindings.includes(c.binding)) {
          setHeaderText = "積卸地"
        } else if (品名Bindings.includes(c.binding)) {
          setHeaderText = "品名"
        } else if (車輌Bindings.includes(c.binding)) {
          setHeaderText = "車輌"
        } else if (請求Bindings.includes(c.binding)) {
          setHeaderText = "請求"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true
        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })

    // ヘッダのみAlignを調整する
    grid.itemFormatter = (panel, r, c, cell) => {
      let setHeaderTextAlign = ""
      if (panel.cellType === wjcGrid.CellType.ColumnHeader) {
        if (r === 0) {
          if (積卸地Bindings.includes(panel.columns[c].binding ?? "")) {
            setHeaderTextAlign = "left"
          } else if (品名Bindings.includes(panel.columns[c].binding ?? "")) {
            setHeaderTextAlign = "left"
          } else if (車輌Bindings.includes(panel.columns[c].binding ?? "")) {
            setHeaderTextAlign = "left"
          } else if (請求Bindings.includes(panel.columns[c].binding ?? "")) {
            setHeaderTextAlign = "left"
          }
        }
        cell.style.textAlign = setHeaderTextAlign
      }
    }
  }

  /**
   * セル編集完了時イベント
   */
  const cellEditEnded = (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    const cellBinding = e.getColumn().binding
    if (cellBinding !== null && e.getRow().dataIndex !== -1) {
      const dataItem: T請求明細入力GridItem = e.getRow().dataItem

      // 受注配車レコードで取り扱っている項目に関しては、同じ受注配車の他レコード(品が異なって膨らんでいるレコード)に同値を展開する
      switch (cellBinding as keyof T請求明細入力GridItem) {
        case "請求車番":
        case "荷主依頼番号":
        case "コンテナNO":
        case "請求運送料課税区分コード":
        case "請求付帯料課税区分コード":
        case "請求備考":
        case "請求計上日":
        case "請求額確認区分コード":
          const 同一受注配車Items: T請求明細入力GridItem[] =
            s.collectionView.sourceCollection.filter(
              (item: T請求明細入力GridItem) => {
                return (
                  dataItem.受注配車ID === item.受注配車ID &&
                  dataItem.積載品ID !== item.積載品ID
                )
              }
            )
          同一受注配車Items.forEach((r) => {
            r.請求車番 = dataItem.請求車番
            r.荷主依頼番号 = dataItem.荷主依頼番号
            r.コンテナNO = dataItem.コンテナNO
            r.請求運送料課税区分コード = dataItem.請求運送料課税区分コード
            r.請求付帯料課税区分コード = dataItem.請求付帯料課税区分コード
            r.請求備考 = dataItem.請求備考
            r.請求計上日 = dataItem.請求計上日
            r.請求額確認区分コード = dataItem.請求額確認区分コード
          })
      }
    }

    // 明細の集計値を算出
    const sumRow: summaryRow = {
      請求合計ID: 0,
      受注配車ID: 0,
      荷主請求ID: 0,
      荷主請求内訳ID: 0,
      積載品ID: 0,
      請求運送料: 0,
      請求付帯料: 0,
      請求高速料: 0,
      請求合計額: 0,
      品数: 0,
    }

    let 運送料 = 0
    let 付帯料 = 0
    let 請求高速料 = 0

    s.collectionView.sourceCollection.forEach((row: T請求明細入力GridItem) => {
      運送料 = row.運送料 ? row.運送料 : 0
      付帯料 = row.付帯料 ? row.付帯料 : 0
      請求高速料 = row.請求高速料 ? row.請求高速料 : 0

      sumRow.請求運送料 += 運送料
      sumRow.請求付帯料 += 付帯料
      sumRow.請求高速料 += 請求高速料
      sumRow.請求合計額 += 運送料 + 付帯料 + 請求高速料
    })
    sumRow.請求運送料 += 固定請求額合計
    sumRow.請求合計額 += 固定請求額合計

    const sumData: T請求明細入力GridItem[] = [sumRow]

    setSummaryGridData({
      data: createSummaryCollectionView(sumData, pageSize),
    })
  }
  const pastedCell = cellEditEnded

  const cellEditEnding = (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellEditEndingEventArgs
  ) => {
    // キャンセルの場合処理しない
    if (e.cancel) return
  }

  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      let col = f.columns[e.col]
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        const dataItem: T請求明細入力GridItem = e.getRow().dataItem
        const is金額Readonly = is請求金額ReadonlyGridRow(dataItem)

        switch (col.binding as keyof T請求明細入力GridItem) {
          case "受注伝票番号":
            if (dataItem.is更新エラー)
              wjCore.toggleClass(e.cell, "update-error", true)
            return
          case "請求高速料":
            if (is金額Readonly) {
              wjCore.toggleClass(e.cell, "read-only-cell", true)
              return
            } else {
              // 高速料請求フラグが設定されている場合、セル背景色を変更
              if (dataItem.高速料請求フラグ === 1) {
                wjCore.toggleClass(e.cell, "kotei-cell-color-23", true)
                return
              }
            }
            break
          case "トン数補償内容":
            //（一次対応）トン数補償フラグが設定されている場合、セル背景色を変更
            if (dataItem.トン数補償フラグ === 1) {
              wjCore.toggleClass(e.cell, "kotei-cell-color-23", true)
              return
            }
            break
          case "運送料":
          case "付帯料":
            if (is金額Readonly) {
              wjCore.toggleClass(e.cell, "read-only-cell", true)
              return
            }
            break
          default:
            break
        }
      }
    }
  }

  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  const beginningEdit = (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    // キャンセルの場合処理しない
    if (e.cancel) return
    if (e.getRow().dataIndex === -1) return

    const col = s.columns[e.col]
    const dataItem: T請求明細入力GridItem = e.getRow().dataItem
    const is金額Readonly = is請求金額ReadonlyGridRow(dataItem)

    switch (col.binding as keyof T請求明細入力GridItem) {
      case "請求高速料":
      case "運送料":
      case "付帯料":
        if (is金額Readonly) {
          e.cancel = true
          return
        }
        break
      default:
        break
    }
  }
  const pastingCell = beginningEdit

  const is請求金額ReadonlyGridRow = (dataItem: T請求明細入力GridItem) => {
    // 品数毎で複数品目を持つ受注配車の場合は金額編集を出来ないようにする(受注配車の単票画面推奨)
    // 品目などで検索されると片側のレコードしかフロントに持ってきておらず、現在の実装だと請求合計金額に影響がでるため
    const is品数毎請求 = dataItem.請求区分コード === e請求支払区分.品数毎
    const has複数品目 = 1 < dataItem.品数
    return is品数毎請求 && has複数品目
  }

  const 請求額確認一括変更ButtonHandler = () => {
    if (searchResult == null) return
    switch (請求処理状態区分コード) {
      case e請求支払処理状態区分.処理済:
        //「請求処理状態区分：処理済」の場合、全明細を「未確認」とする
        searchResult?.forEach((row) => {
          row.請求額確認区分コード = e請求支払確認区分.未確認
        })
        flexGrid?.refresh()
        break

      case e請求支払処理状態区分.確定:
      case e請求支払処理状態区分.送付済:
        //「請求処理状態区分：確定／送付済」の場合、全明細を「確認済」とする
        searchResult?.forEach((row) => {
          row.請求額確認区分コード = e請求支払確認区分.確認済
        })
        flexGrid?.refresh()
        break

      default:
        break
    }
  }

  //#endregion

  //#region [baseState]

  const { state: flexGrid, setState: setFlexGrid } = useContext(FlexGridContext)
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // サマリ用グリッド
  const [summaryFlexGrid, setSummaryFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [summaryGridData, setSummaryGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createSummaryCollectionView([], 1),
  })
  //アラート制御
  //   const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [effect]
  useEffect(() => {
    if (searchResult == null) return
    flexGrid?.refresh()
    setGridData({ data: createCollectionView(searchResult, pageSize) })

    // 明細の集計値を算出
    const sumRow: summaryRow = {
      請求合計ID: 0,
      受注配車ID: 0,
      荷主請求ID: 0,
      荷主請求内訳ID: 0,
      積載品ID: 0,
      請求運送料: 0,
      請求付帯料: 0,
      請求高速料: 0,
      請求合計額: 0,
      品数: 0,
    }
    let 固定請求額 = 0

    searchResult.forEach((row) => {
      sumRow.請求運送料 += row.運送料
      sumRow.請求付帯料 += row.付帯料
      sumRow.請求高速料 += row.請求高速料
      sumRow.請求合計額 += row.運送料 + row.付帯料 + row.請求高速料
      固定請求額 = row.固定請求額合計
    })
    sumRow.請求運送料 += 固定請求額
    sumRow.請求合計額 += 固定請求額

    const sumData: T請求明細入力GridItem[] = [sumRow]

    setSummaryGridData({
      data: createSummaryCollectionView(sumData, pageSize),
    })
    set固定請求額合計(固定請求額)

    //区分値の確保
    //TODO: APIより区分の一覧を取得し各dataMapにフィルターしながら設定
    if (searchResult.length > 0) {
      const 荷主請求IdList = _.uniq(
        searchResult
          .filter((a) => a.荷主請求ID != null)
          .map((a) => a.荷主請求ID)
      )

      Promise.all([
        new NinusiSeikyuService().getListUchiwake({
          荷主請求IdList,
        }),
      ]).then(([請求内訳Res]) => {
        set請求内訳DataMap(
          new wjcGrid.DataMap(請求内訳Res.data, "荷主請求内訳ID", "請求内訳名")
        )
      })

      // 高速料項目の表題を取得
      // 明細画面の高速料は税込額のため切替しない、請求高速料税込区分が税抜の場合は注釈表示
      set高速料項目表題("高速料（税込）")
      if (searchResult[0].請求高速料税込区分名称 === "税抜") {
        // set高速料項目表題(
        //   "高速料（" + searchResult[0].請求高速料税込区分名称 + "）"
        // )
        set高速料注釈(
          "※高速料は税込みで表示されていますが、請求書は税抜きで作成されます。"
        )
      } else {
        set高速料注釈("")
      }

      // 固定請求額編集モーダル起動ボタンの表示可否を取得
      setIs固定請求編集(searchResult[0].固定請求データ件数 > 0 ? "" : "none")

      // 固定請求額編集モーダル用の請求伝票番号を取得
      set請求伝票番号(searchResult[0].請求伝票番号)
    }
  }, [searchResult])

  //初期表示

  useEffect(() => {
    //区分値の確保
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      set請求区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.請求区分
          ),
          "区分コード",
          "名称1"
        )
      )
      set課税区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.課税区分
          ),
          "区分コード",
          "名称1"
        )
      )
      set請求額確認区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) =>
              d.分類コード === 区分分類コード.受注配車_請求支払.請求支払確認区分
          ),
          "区分コード",
          "名称1"
        )
      )
    })
  }, [])

  useEffect(() => {
    if (!請求処理状態区分IsLoadEnded) return

    if (searchResult != null && searchResult.length > 0) {
      // 請求処理状態区分の初期選択値を設定
      set請求処理状態区分コード(searchResult[0].請求処理状態区分コード)
      set請求処理状態区分初期コード(searchResult[0].請求処理状態区分コード)
    } else {
      // 固定請求額編集モーダル起動ボタンを非表示
      setIs固定請求編集("none")
    }
  }, [請求処理状態区分IsLoadEnded, searchResult])

  // 固定請求額更新時の請求合計への反映
  useEffect(() => {
    if (isUpdateKoteiSeikyu) {
      const summaryData: T請求明細入力GridItem =
        summaryFlexGrid?.collectionView.sourceCollection[0]

      const sumRow: summaryRow = {
        請求合計ID: 0,
        受注配車ID: 0,
        荷主請求ID: 0,
        荷主請求内訳ID: 0,
        積載品ID: 0,
        請求運送料: summaryData.請求運送料 ?? 0,
        請求付帯料: summaryData.請求付帯料 ?? 0,
        請求高速料: summaryData.請求高速料 ?? 0,
        請求合計額: 0,
        品数: 0,
      }
      sumRow.請求運送料 += 固定請求額差分
      sumRow.請求合計額 =
        sumRow.請求運送料 + sumRow.請求付帯料 + sumRow.請求高速料

      const sumData: T請求明細入力GridItem[] = [sumRow]

      setSummaryGridData({
        data: createSummaryCollectionView(sumData, pageSize),
      })

      const 更新後固定請求額合計 = 固定請求額合計 + 固定請求額差分
      set固定請求額合計(更新後固定請求額合計)
    }
  }, [isUpdateKoteiSeikyu])

  //ファンクション内部のstate更新のためイベント付け替え
  useEffect(() => {
    flexGrid?.formatItem.removeHandler(formatItem)
    flexGrid?.formatItem.addHandler(formatItem)
    flexGrid?.beginningEdit.removeHandler(beginningEdit)
    flexGrid?.beginningEdit.addHandler(beginningEdit)
    flexGrid?.cellEditEnding.removeHandler(cellEditEnding)
    flexGrid?.cellEditEnding.addHandler(cellEditEnding)
    flexGrid?.pastingCell.removeHandler(pastingCell)
    flexGrid?.pastingCell.addHandler(pastingCell)
    flexGrid?.cellEditEnded.removeHandler(cellEditEnded)
    flexGrid?.cellEditEnded.addHandler(cellEditEnded)
    flexGrid?.pastedCell.removeHandler(pastedCell)
    flexGrid?.pastedCell.addHandler(pastedCell)
  }, [flexGrid, summaryFlexGrid, 固定請求額合計])
  //#endregion

  return (
    <>
      {/* 合計カード */}
      <div>
        <Row>
          <Col>
            <FlexGridOuter
              flexGrid={summaryFlexGrid}
              gridConstantProperties={
                CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_TOTAL
              }
              setFlexGrid={setSummaryFlexGrid}
              gridData={summaryGridData}
              setGridData={setSummaryGridData}
              pageNumber={pageNumber}
              gridId={`${props.gridId}_1`}
              isRestoreSearching={isRestoreSearching}
              setIsRestoreSearching={setIsRestoreSearching}
              gridInitialized={gridInitialized}
              setGridInitialized={setGridInitialized}
              pageSize={pageSize}
              setPageSize={setPageSize}
              isShowGridFooter={false}
              isShowGridHeader={false}
              isShowGridRowPickupButton={false}
              hasFilter={false}>
              <wjrGrid.FlexGridColumn
                binding="請求運送料"
                cssClass="number-col"
                cssClassAll={"read-only-cell"}
                width={128}
                header="運送料・その他"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="請求付帯料"
                cssClass="number-col"
                width={128}
                cssClassAll={"read-only-cell"}
                header="運送付帯料"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="請求高速料"
                cssClass="number-col"
                width={128}
                cssClassAll={"read-only-cell"}
                header={高速料項目表題}></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="請求合計額"
                cssClass="number-col"
                width={128}
                header="合計額"
                cssClassAll={"read-only-cell"}></wjrGrid.FlexGridColumn>
            </FlexGridOuter>
          </Col>
          <Col>
            <table className="h-100">
              <tbody>
                <tr>
                  <td rowSpan={2} className="seikyu-syoki-display-cell">
                    <div
                      style={{
                        backgroundColor: "var(--read-only-cell)",
                        borderColor: "rgba(0,0,0,0.2)",
                      }}
                      className="h-100 text-center align-middle me-2 border solid border-2">
                      <div
                        style={{
                          background: "#e0e0e0",
                          height: "2.5rem",
                          width: "10rem",
                          fontWeight: "700",
                        }}
                        className="border-bottom border-1 d-flex justify-content-center align-items-center">
                        <div>請求処理状態</div>
                      </div>
                      <div
                        style={{
                          height: "calc(100% - 2.5rem)",
                        }}
                        className="d-flex justify-content-center align-items-center">
                        <div>
                          {
                            props?.区分ItemSource
                              ?.filter(
                                (i) =>
                                  i.分類コード ===
                                  区分分類コード.受注配車_請求支払
                                    .請求支払処理状態区分
                              )
                              ?.find(
                                (i) =>
                                  i.区分コード === 請求処理状態区分初期コード
                              )?.名称1
                          }
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="w-12rem d-inline-block">
                      <ComboBox.Kubun
                        placeholder="請求処理状態変更"
                        分類コード={
                          区分分類コード.受注配車_請求支払.請求支払処理状態区分
                        }
                        isLoadEnded={請求処理状態区分IsLoadEnded}
                        setIsLoadEnded={set請求処理状態区分IsLoadEnded}
                        itemsSource={props.区分ItemSource}
                        selectedValue={請求処理状態区分コード}
                        isDisabled={searchResult == null}
                        setSelectedValue={set請求処理状態区分コード}
                        ComboBox={請求処理状態区分ComboBox}
                        setComboBox={
                          set請求処理状態区分ComboBox
                        }></ComboBox.Kubun>
                    </div>
                    <div className="d-inline-block ms-2">
                      <Button onClick={請求額確認一括変更ButtonHandler}>
                        請求額確認一括変更
                      </Button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="text-danger">
                    請求処理状態・請求額確認は更新ボタン押下時にデータが更新されます
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
          <Row>
            <span className="text-danger">{高速料注釈}</span>
          </Row>
        </Row>
      </div>
      <FlexGridOuter
        flexGrid={flexGrid}
        setFlexGrid={setFlexGrid}
        gridConstantProperties={CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
        gridData={gridData}
        setGridData={setGridData}
        pageNumber={pageNumber}
        searchConditionClear={props.searchConditionClear}
        gridId={`${props.gridId}_2`}
        isRestoreSearching={isRestoreSearching}
        isEnablePageSize={"hidden"}
        setIsRestoreSearching={setIsRestoreSearching}
        gridInitialized={gridInitialized}
        setGridInitialized={setGridInitialized}
        pageSize={pageSize}
        setPageSize={setPageSize}
        gridInitializedHandler={gridInitializedHandler}
        excelFormatItem={invoiceListExcelFormat}
        pdfFormatItem={invoiceListPdfFormat}
        gridProperties={{
          frozenColumns: 1,
          isReadOnly: false,
          allowMerging: wjcGrid.AllowMerging.ColumnHeaders,
          headersVisibility: wjcGrid.HeadersVisibility.All,
          keyActionTab: wjcGrid.KeyAction.CycleOut,
        }}
        headerComponent={
          <>
            <Link
              to={`${請求明細入力PathList[0]}`}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                gridPageHelper.savePageConditionData(location.pathname)
              }}></Link>
            <Button
              disabled={isSearching}
              style={{ display: is固定請求編集 }}
              onClick={() => {
                setIsShow(true)
                setIsUpdateKoteiSeikyu(false)
                set固定請求額差分(0)
              }}>
              月固定請求
            </Button>
            {/* 
            TODO:その他請求ポップアップは一旦保留
            <Button
              disabled={isSearching}
              onClick={() => setIsOthersModalShow(true)}>
              その他請求入力
            </Button> */}
          </>
        }>
        <wjrGrid.FlexGridColumn
          binding="受注伝票番号"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={110}
          header="受注No"></wjrGrid.FlexGridColumn>
        {/* <wjrGrid.FlexGridColumn
          binding="枝番"
          width={32}
          cssClass={"read-only-cell"}
          header="枝番"></wjrGrid.FlexGridColumn> */}
        <wjrGrid.FlexGridColumn
          binding="積日"
          width={96}
          isReadOnly={true}
          cssClass={"read-only-cell"}
          header="積日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<T請求明細入力GridItem>
            ) => {
              let dDate = ""
              if (context.item.積日)
                dDate = dayjs(context.item.積日).format("MM/DD")
              return (
                <>
                  <span>{dDate}</span>
                </>
              )
            }}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸日"
          width={96}
          isReadOnly={true}
          cssClass={"read-only-cell"}
          header="卸日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<T請求明細入力GridItem>
            ) => {
              let dDate = ""
              if (context.item.卸日)
                dDate = dayjs(context.item.卸日).format("MM/DD")
              return (
                <>
                  <span>{dDate}</span>
                </>
              )
            }}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        {/* 車両 */}
        <wjrGrid.FlexGridColumn
          binding="車番"
          width={85}
          isReadOnly={true}
          cssClass={"read-only-cell"}
          header="車番"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="トレーラ車番"
          width={85}
          isReadOnly={true}
          cssClass={"read-only-cell"}
          header="トレーラ"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="乗務員名"
          width={128}
          isReadOnly={true}
          cssClass={"read-only-cell"}
          header="乗務員"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="運行部所名"
          width={128}
          isReadOnly={true}
          cssClass={"read-only-cell"}
          header="運行部所"></wjrGrid.FlexGridColumn>
        {/* 積卸地 */}
        <wjrGrid.FlexGridColumn
          binding="積場社名"
          width={150}
          isReadOnly={true}
          cssClass={"read-only-cell"}
          header="積地社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積場地名"
          width={150}
          isReadOnly={true}
          cssClass={"read-only-cell"}
          header="積市区町村"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸場社名"
          width={150}
          isReadOnly={true}
          cssClass={"read-only-cell"}
          header="卸地社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸場地名"
          width={150}
          isReadOnly={true}
          cssClass={"read-only-cell"}
          header="卸市区町村"></wjrGrid.FlexGridColumn>
        {/* 品名 */}
        <wjrGrid.FlexGridColumn
          binding="disp品コード"
          width={80}
          isReadOnly={true}
          cssClass={"read-only-cell"}
          header="品CD"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="品名"
          width={150}
          isReadOnly={true}
          cssClass={"read-only-cell"}
          header="品名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="数量"
          width={80}
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          format={"N3"}
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          header="数量"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="単位区分名称"
          width={64}
          isReadOnly={true}
          cssClass={"read-only-cell"}
          header="単位"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="トン数補償内容"
          width={128}
          isReadOnly={true}
          cssClass={"read-only-cell"}
          header="トン数補償"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="荷主依頼番号"
          width={128}
          header="荷主依頼No"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="コンテナNO"
          width={128}
          header="コンテナNo"></wjrGrid.FlexGridColumn>
        {/* 請求 */}
        <wjrGrid.FlexGridColumn
          binding="荷主請求内訳ID"
          width={150}
          dataMap={請求内訳DataMap}
          header="請求内訳"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求区分名称"
          dataMap={請求区分DataMap}
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          header="請求区分"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求車番"
          header="請求車番"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="単価"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="数量単価"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          isReadOnly={true}
          binding="履歴検索"
          width={60}
          header="履歴">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<T請求明細入力GridItem>
            ) => {
              return (
                <a
                  href="*"
                  onClick={(e) => {
                    e.preventDefault()
                    // setSelectRow(context.row)
                    // setIsModalShow(true)
                  }}>
                  <FontAwesomeIcon icon={faSearch} />
                </a>
              )
            }}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn width={80} binding="タリフ検索" header="タリフ">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<T請求明細入力GridItem>
            ) => {
              return (
                <a
                  href="*"
                  onClick={(e) => {
                    e.preventDefault()
                    // setSelectRow(context.row)
                    // setIsModalShow(true)
                  }}>
                  <FontAwesomeIcon icon={faSearch} />
                </a>
              )
            }}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求運送料課税区分コード"
          width={80}
          dataMap={課税区分DataMap}
          header="非/課"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="運送料"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="運送料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求付帯料課税区分コード"
          width={80}
          dataMap={課税区分DataMap}
          header="非/課"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="付帯料"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="付帯料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求高速料"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          header="高速料(税込)"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求額合計"
          cssClass="number-col"
          dataType={wjCore.DataType.Number}
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="請求額合計"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求備考"
          header="請求備考"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="計上基準日区分名称"
          cssClassAll={"read-only-cell"}
          isReadOnly={true}
          header="請求基準"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求計上日"
          editor={
            new wjcInput.InputDate(document.createElement("div"), {
              format: "yyyyMMdd",
            })
          }
          format={"d"}
          header="請求計上日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<T請求明細入力GridItem>
            ) => {
              let dDate = ""
              if (context.item.請求計上日)
                dDate = dayjs(context.item.請求計上日).format("YYYY/MM/DD")

              return (
                <>
                  <span>{dDate}</span>
                </>
              )
            }}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="請求額確認区分コード"
          width={128}
          dataMap={請求額確認区分DataMap}
          header="請求額確認"></wjrGrid.FlexGridColumn>
      </FlexGridOuter>
      {/* 更新 */}
      {/* 運賃タリフ検索　AGCロジ高速料 */}
      {/* ETC高速料 */}
      <InvoiceListKoteiSeikyuModal
        isShow={isShow}
        setIsShow={setIsShow}
        isUpdateKoteiSeikyu={isUpdateKoteiSeikyu}
        setIsUpdateKoteiSeikyu={setIsUpdateKoteiSeikyu}
        固定請求額差分={固定請求額差分}
        set固定請求額差分={set固定請求額差分}
        請求合計更新日時={請求合計更新日時}
        set請求合計更新日時={set請求合計更新日時}
        size={"lg"}
        title={"月固定請求明細"}
        請求伝票番号={請求伝票番号}
        請求年月={請求年月}></InvoiceListKoteiSeikyuModal>
    </>
  )
}

export default InvoiceListGrid
